import axios from 'axios';
import { urlRols } from '../utils';

export const apiRol = axios.create({
    baseURL: `${urlRols}`
});